import styled from 'styled-components';

import { hiddenMixin } from 'core/ui/mixins';

const Hr = styled.hr`
  background-color: ${(p) => p.theme.colors.green.light};
  border: 0;
  width: 100%;
  height: 0.5px;
  ${(p) => p.grayed && `background-color: ${p.theme.colors.grays.light};`};
  ${hiddenMixin}
`;

export default Hr;
